import React from 'react';
import _ from 'lodash';
import type { ShopConfig } from 'domain-model/types/supplier-gateway';
import ProductCategoryLink from './ProductCategoryLink';

export default function ArticleBreadCrumbs({
  productCategory,
  organizationProductCategory,
  shopConfig,
  className,
}: {
  productCategory: string;
  organizationProductCategory?: string;
  shopConfig: ShopConfig;
  className?: string;
}) {
  const categoryTreeToUse = shopConfig.usesOrganizationProductCategories
    ? organizationProductCategory
    : productCategory;

  const splitCategory = (categoryTreeToUse ?? '').split('|');
  const allCategoryPipeStrings = splitCategory.map((category, index) => {
    return splitCategory.slice(0, index + 1).join('|');
  });

  return allCategoryPipeStrings.map((category, index) => (
    <span key={index}>
      <ProductCategoryLink
        key={index}
        productCategory={category}
        organizationProductCategory={category}
        className={`${className} article-breadcrumbs`}
      />
      {index < splitCategory.length - 1 && (
        <span className={className}> {' > '} </span>
      )}
    </span>
  ));
}
